//*** Import React Library
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Table from "react-data-table-component";
import Button from "react-bootstrap/Button";
import Axios from 'axios'
import "../../Assets/Styles/robot.css";
import AxiosInstance from '../Axios/AxiosInstance';
///*** Global Variables 
var PlantID = "1";
const RobotID = "FB001";
var Current_data = null;
//***End Global Variables
let _plantID = (new URLSearchParams(window.location.search)).get("pid")
PlantID = _plantID;
const columns = [
    { name: "Sr. No.", selector: (row) => row.id + 1, sortable: true },
    { name: "Robot Name", selector: (row) => row.robotName, sortable: true },
    { name: "Block Name", selector: (row) => row.blockName, sortable: true },
    { name: "Row Name", selector: (row) => row.rowName, sortable: true },
    { name: "Controller Battery", selector: (row) => row.controllerBatteryStatus, sortable: true },
    { name: "Motor Battery", selector: (row) => row.motorBatteryStatus, sortable: true },
    { name: "Date", selector: (row) => row.workingDate, sortable: true },
    { name: "Time(mm:ss)", selector: (row) => row.workingTime, sortable: true }
];
const customStyles = {
    table: {
        style: {
            border: "none",
            fontSize: "100%"
        },
    },
    header: {
        backgroundColor: "transparent",
    },
    rows: {
        style: {
            backgroundColor: "transparent",
        },
    },
    headRow: {
        style: {
            backgroundColor: "transparent",
            fontSize: "110%"
        },
    },
    pagination: {
        style: {
            backgroundColor: "transparent",
            fontWeight: "600",
        },
    },
    headCells: {
        style: {
            borderBottom: "none",
            fontWeight: "700",
            fontSize: "110%"
        },
    },
};
export const CurrentBatteryStatus = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const [data, setData] = useState([])
    const [List, setList] = useState([])
    const [SelectedList, setSelectedList] = useState([])
    const [MasterChecked, setMasterChecked] = useState(false)
    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
        let tempList = data;
        const filteredData = tempList.filter((event) =>
            Object.values(event).some(
                (value) => typeof value === "string" && value.includes(searchTerm)
            )
        );
        if (event.target.value != null) {
            setList(filteredData);
        }
        if (event.target.value == "") {
            setList(data);
        }
    };
    const filteredData = List.filter((event) =>
        Object.values(event).some(
            (value) => typeof value === "string" && value.includes(searchTerm)
        )
    );
    const handleRowSelected = (rows) => {
        setData(rows.selectedRows);
    };
    const contextActions = (
        <button onClick={() => alert(data.map((r) => r.robotID))}>
            Show Selected Rows
        </button>
    );
    useEffect(() => {
        fetchData();
    }, [])
    useEffect(() => {
        console.log(data)
    }, [data])
    const fetchData = async () => {
        var plant_id = sessionStorage.getItem("user_plantid");
        try { 
            const response = await AxiosInstance.get("/PlantRobotsOperation?pid=" + plant_id + "&rt=multiple");
            setData(response.data)
            setList(response.data)
            //if (response && typeof response.then === 'function') {
            //response.then((res) => {
            //        alert("ok")
            //        if (res.status === 200) {
            //            setData(response.data)
            //            setList(response.data)
            //            console.log("OK: The request was successful, and the server responded with the requested data.")
            //        }
            //        else if (res.status === 201) {
            //            console.log("Created:The request was successful, and a new resource was created.")
            //        }
            //        else if (res.status === 204) {
            //            console.log("No Content: The request was successful, but there is no content to send in the response.")
            //        }
            //        if (res.data) {
            //            setData(response.data)
            //            setList(response.data)
            //        }
            //    })
            //    response.catch(
            //        function (error) {
            //            console.log('Error Message:' + error)
            //        }
            //    )
            //}
            //else {
            //    console.log("Response is not a promise");
            //}
        }
        catch (error) {
            console.log('Error Message:' + error)
        }
    }
    return (
        <>
            <h3 style={{ margin: "2%", marginLeft:"2%" }}>Robot's Current Battery Status</h3>
            <div
                style={{
                    border: "1px solid #c0c0c0",
                    borderRadius: "5px",
                    margin: "2%",
                    backgroundColor: "#fff",
                }}
              >
                <div className="container dvscroll" style={{ width: "100%", height: "70%", fontSize: "92%" }} >
                    <div className="row dvscroll">
                        <div className="col-sm-12">
                            <input
                                type="text"
                                placeholder="Search Results"
                                style={{
                                    width: "20%",
                                    height: "30px",
                                    margin: "10px",
                                    float: "right",
                                    border: "none",
                                    padding: "1.5%",
                                    borderRadius: "5px",
                                }}
                                value={searchTerm}
                                onChange={handleSearch}
                            />
                            <p></p>
                            <DataTable className="table .table-sm table-hover" sort={true} pagination={true}
                                search={true}
                                columns={columns}
                                data={filteredData}
                                highlightOnHover={true}
                                customStyles={customStyles}
                            >
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
